export default __webpack_public_path__ + "static/media/contactImg.4a83d2d8.jpg";